export default __webpack_public_path__ + "static/media/blocks.0fd8b547.svg";